function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_14",
  "data-name": "Path 14",
  d: "M85.327,425.093h-.018a1.7,1.7,0,0,1-1.734-1.68V393.766H68.719v29.647a1.7,1.7,0,0,1-1.734,1.68h-.018a9.271,9.271,0,1,0,0,18.513,10.013,10.013,0,0,0,6.95-2.75,3.243,3.243,0,0,1,4.459,0,10.014,10.014,0,0,0,6.95,2.75,9.271,9.271,0,1,0,0-18.513Z",
  transform: "translate(-28.588 -202.401)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_15",
  "data-name": "Path 15",
  d: "M71.748,442.42c-6.117-1.829-7.247-11.139-1.043-14.287a5.365,5.365,0,0,0,3-4.8c-.044-5.559-.159-10.717-.159-14.167a28.228,28.228,0,0,0,10.035-.354V393.766H68.721v29.593a1.739,1.739,0,0,1-1.734,1.734h-.018a9.271,9.271,0,1,0,0,18.513A10.138,10.138,0,0,0,71.748,442.42Z",
  transform: "translate(-28.589 -202.401)",
  fill: "rgba(147,147,147,0.69)",
  opacity: 0.05
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_16",
  "data-name": "Path 16",
  d: "M95.117,273.57a32.692,32.692,0,1,0-53.386,25.3A13.313,13.313,0,0,1,46.513,309.2v1.841a15.913,15.913,0,0,0,15.913,15.913h0a15.913,15.913,0,0,0,15.913-15.913v-1.872a13.718,13.718,0,0,1,5.031-10.5A32.609,32.609,0,0,0,95.117,273.57Z",
  transform: "translate(-14.866 -125.961)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_17",
  "data-name": "Path 17",
  d: "M105.168,298.663A32.687,32.687,0,0,0,82.948,240.9a32.222,32.222,0,0,0-8.977,1.633,79.524,79.524,0,0,0,.066,20.612,83.489,83.489,0,0,0,25.952,50.04,16.052,16.052,0,0,0,.149-2.15v-1.872A13.718,13.718,0,0,1,105.168,298.663Z",
  transform: "translate(-36.664 -125.961)",
  fill: "rgba(147,147,147,0.69)",
  opacity: 0.2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_18",
  "data-name": "Path 18",
  d: "M378.954,434.349a9.533,9.533,0,0,0,9.788,9.257,10.013,10.013,0,0,0,6.95-2.75,3.243,3.243,0,0,1,4.459,0,10.014,10.014,0,0,0,6.95,2.75,9.271,9.271,0,1,0,0-18.513h-.018a1.7,1.7,0,0,1-1.734-1.68V393.766H390.494v29.647a1.7,1.7,0,0,1-1.734,1.68h-.018A9.533,9.533,0,0,0,378.954,434.349Z",
  transform: "translate(-189.466 -202.401)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_19",
  "data-name": "Path 19",
  d: "M393.523,442.42c-6.117-1.829-7.247-11.139-1.043-14.287a5.365,5.365,0,0,0,3-4.8c-.043-5.559-.159-10.717-.159-14.167a28.228,28.228,0,0,0,10.035-.354V393.766H390.5v29.593a1.739,1.739,0,0,1-1.734,1.734h-.018a9.271,9.271,0,1,0,0,18.513A10.138,10.138,0,0,0,393.523,442.42Z",
  transform: "translate(-189.467 -202.401)",
  fill: "rgba(147,147,147,0.69)",
  opacity: 0.05
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_20",
  "data-name": "Path 20",
  d: "M351.508,273.57a32.692,32.692,0,1,1,53.386,25.3,13.313,13.313,0,0,0-4.781,10.326v1.841A15.913,15.913,0,0,1,384.2,326.951h0a15.913,15.913,0,0,1-15.913-15.913v-1.872a13.718,13.718,0,0,0-5.031-10.5A32.608,32.608,0,0,1,351.508,273.57Z",
  transform: "translate(-175.744 -125.961)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_21",
  "data-name": "Path 21",
  d: "M363.255,298.663a32.687,32.687,0,0,1,22.22-57.761,32.226,32.226,0,0,1,8.977,1.633,79.548,79.548,0,0,1-.066,20.612,83.489,83.489,0,0,1-25.952,50.04,16.047,16.047,0,0,1-.148-2.15v-1.872A13.718,13.718,0,0,0,363.255,298.663Z",
  transform: "translate(-175.744 -125.961)",
  fill: "rgba(147,147,147,0.69)",
  opacity: 0.2
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_22",
  "data-name": "Path 22",
  d: "M65.381,88.235l1.753-8.025A15.153,15.153,0,0,0,51.823,61.832L13.976,63.1a6.7,6.7,0,0,0-6.476,6.7h0A6.7,6.7,0,0,0,13.1,76.4l24.66,4.1a3.924,3.924,0,0,1,3.1,5.051l-3.6,11.414A21.455,21.455,0,0,0,57.724,124.87H78.113A15.79,15.79,0,0,0,93.9,109.08h0a15.79,15.79,0,0,0-15.79-15.79H69.452A4.166,4.166,0,0,1,65.381,88.235Z",
  transform: "translate(-3.75 -36.439)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path_23",
  "data-name": "Path 23",
  d: "M121.306,124.579h-8.66a4.171,4.171,0,0,1-1.179-.175,68.671,68.671,0,0,1-11.042,20.72,78.967,78.967,0,0,0-6.533,9.859,21.463,21.463,0,0,0,7.026,1.176h20.389a15.79,15.79,0,0,0,15.79-15.79h0A15.791,15.791,0,0,0,121.306,124.579Z",
  transform: "translate(-46.943 -67.728)",
  fill: "rgba(147,147,147,0.69)",
  opacity: 0.2
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Path_24",
  "data-name": "Path 24",
  d: "M360.226,88.235l-1.753-8.025a15.153,15.153,0,0,1,15.311-18.378L411.632,63.1a6.7,6.7,0,0,1,6.476,6.7h0a6.7,6.7,0,0,1-5.6,6.609l-24.66,4.1a3.924,3.924,0,0,0-3.1,5.051l3.6,11.414a21.455,21.455,0,0,1-20.462,27.907H347.495a15.79,15.79,0,0,1-15.79-15.79h0a15.79,15.79,0,0,1,15.79-15.79h8.66A4.167,4.167,0,0,0,360.226,88.235Z",
  transform: "translate(-165.843 -36.439)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "Path_25",
  "data-name": "Path 25",
  d: "M347.5,124.579h8.661a4.171,4.171,0,0,0,1.179-.175,68.671,68.671,0,0,0,11.042,20.72,78.966,78.966,0,0,1,6.533,9.859,21.462,21.462,0,0,1-7.026,1.176H347.495a15.79,15.79,0,0,1-15.79-15.79h0A15.79,15.79,0,0,1,347.5,124.579Z",
  transform: "translate(-165.843 -67.728)",
  fill: "rgba(147,147,147,0.69)",
  opacity: 0.2
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "Path_26",
  "data-name": "Path 26",
  d: "M227.222,70.1,221.46,47.746a38.9,38.9,0,0,0-37.669-29.188H169.819a38.9,38.9,0,0,0-37.668,29.188L126.388,70.1a81.25,81.25,0,0,1-14.514,29.561h0A67.87,67.87,0,0,0,98.21,150.37h0a71.365,71.365,0,0,0,70.724,61.822h15.742A71.365,71.365,0,0,0,255.4,150.37h0a67.871,67.871,0,0,0-13.663-50.712h0A81.251,81.251,0,0,1,227.222,70.1Z",
  transform: "translate(-48.797 -14.808)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "Path_27",
  "data-name": "Path 27",
  d: "M146.162,89.964c-4-27.614-4.137-53.348,12.619-68.208a38.905,38.905,0,0,0-26.632,27.59L126.387,71.7a81.25,81.25,0,0,1-14.514,29.561h0a67.871,67.871,0,0,0-13.663,50.712h0a71.365,71.365,0,0,0,70.724,61.822h15.742a71.127,71.127,0,0,0,32.121-7.634C99.8,204.718,152.677,134.93,146.162,89.964Z",
  transform: "translate(-48.797 -16.406)",
  fill: "rgba(147,147,147,0.69)",
  opacity: 0.1
});

var _ref16 = /*#__PURE__*/React.createElement("g", {
  id: "Group_8",
  "data-name": "Group 8",
  transform: "translate(29.456 21.778)",
  opacity: 0.1
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_22",
  "data-name": "Ellipse 22",
  cx: 3.606,
  cy: 3.606,
  r: 3.606,
  transform: "translate(47.188 82.788)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_23",
  "data-name": "Ellipse 23",
  cx: 3.606,
  cy: 3.606,
  r: 3.606,
  transform: "translate(81.635 41.625)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_24",
  "data-name": "Ellipse 24",
  cx: 3.606,
  cy: 3.606,
  r: 3.606,
  transform: "translate(105.211)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_25",
  "data-name": "Ellipse 25",
  cx: 3.606,
  cy: 3.606,
  r: 3.606,
  transform: "translate(190.756 124.37)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_26",
  "data-name": "Ellipse 26",
  cx: 3.606,
  cy: 3.606,
  r: 3.606,
  transform: "translate(174.15 44.566)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_27",
  "data-name": "Ellipse 27",
  cx: 3.606,
  cy: 3.606,
  r: 3.606,
  transform: "translate(18.106 19.164)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_28",
  "data-name": "Ellipse 28",
  cx: 3.606,
  cy: 3.606,
  r: 3.606,
  transform: "translate(152.819 93.138)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_29",
  "data-name": "Ellipse 29",
  cx: 3.606,
  cy: 3.606,
  r: 3.606,
  transform: "translate(122.272 143.386)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_30",
  "data-name": "Ellipse 30",
  cx: 3.606,
  cy: 3.606,
  r: 3.606,
  transform: "translate(0 111.29)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_31",
  "data-name": "Ellipse 31",
  cx: 3.606,
  cy: 3.606,
  r: 3.606,
  transform: "translate(15.741 154.732)",
  fill: "rgba(147,147,147,0.69)"
}));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  id: "Group_9",
  "data-name": "Group 9",
  transform: "translate(90.154 26.817)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_32",
  "data-name": "Ellipse 32",
  cx: 3.606,
  cy: 3.606,
  r: 3.606,
  transform: "translate(0 131.137)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_33",
  "data-name": "Ellipse 33",
  cx: 3.606,
  cy: 3.606,
  r: 3.606,
  transform: "translate(85.61 66.538)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_34",
  "data-name": "Ellipse 34",
  cx: 3.606,
  cy: 3.606,
  r: 3.606,
  transform: "translate(72.099 91.705)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_35",
  "data-name": "Ellipse 35",
  cx: 3.606,
  cy: 3.606,
  r: 3.606,
  transform: "translate(111.091 11.71)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_36",
  "data-name": "Ellipse 36",
  cx: 3.606,
  cy: 3.606,
  r: 3.606,
  transform: "translate(97.311 104.156)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_37",
  "data-name": "Ellipse 37",
  cx: 3.606,
  cy: 3.606,
  r: 3.606,
  transform: "translate(13.726)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_38",
  "data-name": "Ellipse 38",
  cx: 3.606,
  cy: 3.606,
  r: 3.606,
  transform: "translate(117.057 149.693)",
  fill: "rgba(147,147,147,0.69)"
}));

var _ref18 = /*#__PURE__*/React.createElement("path", {
  id: "Path_28",
  "data-name": "Path 28",
  d: "M245.915,33.968,208.068,32.7a18.9,18.9,0,0,0-19.1,22.927l1.753,8.025a.417.417,0,0,1-.407.505h-8.579L177.05,46a3.751,3.751,0,0,0-7.263,1.873l5.006,19.413A84.534,84.534,0,0,0,189.977,98.21a64.5,64.5,0,0,1,12.908,47.91,67.614,67.614,0,0,1-67.007,58.573H120.136a67.614,67.614,0,0,1-67.007-58.574A64.505,64.505,0,0,1,66.036,98.21,84.468,84.468,0,0,0,80.708,69.172h0c.177-.627.35-1.256.513-1.888l5.763-22.351A35.144,35.144,0,0,1,121.02,18.559h13.971a35.272,35.272,0,0,1,28.433,14.478,3.75,3.75,0,1,0,6.064-4.413,42.8,42.8,0,0,0-34.5-17.566H121.02a42.643,42.643,0,0,0-41.3,32l-5.44,21.1H65.7a.417.417,0,0,1-.407-.505l1.753-8.025A18.9,18.9,0,0,0,47.945,32.7L10.1,33.968A10.45,10.45,0,0,0,8.738,54.721l24.66,4.1a.174.174,0,0,1,.137.224l-3.6,11.413a25.2,25.2,0,0,0,23.893,32.78,72.311,72.311,0,0,0-7.085,19.01c-.2,0-.4,0-.6.007A36.672,36.672,0,0,0,11.17,156.676,36.147,36.147,0,0,0,24.489,186.87,9.074,9.074,0,0,1,27,190.146a3.75,3.75,0,1,0,6.817-3.126,16.748,16.748,0,0,0-4.578-5.955,28.72,28.72,0,0,1-10.58-23.99A29.122,29.122,0,0,1,45.5,129.8a71.123,71.123,0,0,0,.194,17.319,75.093,75.093,0,0,0,16.7,38,17.1,17.1,0,0,0-2.67,9.145v1.872a12.164,12.164,0,0,1-22.036,7.106,3.75,3.75,0,0,0-6.082,4.388A19.634,19.634,0,0,0,36.38,212.3v17.845a12.983,12.983,0,0,0,2,25.873,13.726,13.726,0,0,0,9.18-3.455,13.727,13.727,0,0,0,9.18,3.455,12.981,12.981,0,0,0,2-25.87V212.3a19.653,19.653,0,0,0,8.485-16.164v-1.872a9.454,9.454,0,0,1,.6-3.285q1.4,1.36,2.875,2.654a75.1,75.1,0,0,0,49.436,18.561h15.742a75.1,75.1,0,0,0,49.436-18.561q1.477-1.291,2.875-2.654a9.452,9.452,0,0,1,.6,3.285v1.872a19.652,19.652,0,0,0,8.485,16.164v17.843a12.983,12.983,0,0,0,2,25.873,13.726,13.726,0,0,0,9.18-3.455,13.727,13.727,0,0,0,9.18,3.455,12.981,12.981,0,0,0,2-25.87V212.3a19.653,19.653,0,0,0,8.485-16.164v-1.842a9.51,9.51,0,0,1,3.407-7.424,36.146,36.146,0,0,0,13.318-30.193,36.671,36.671,0,0,0-34.971-34.424c-.2-.008-.4,0-.6-.007a72.311,72.311,0,0,0-7.085-19.01,25.2,25.2,0,0,0,23.893-32.78l-3.6-11.414a.158.158,0,0,1,.018-.144.16.16,0,0,1,.12-.081l24.66-4.1a10.45,10.45,0,0,0-1.361-20.753ZM39.7,88.5A17.532,17.532,0,0,1,37.09,72.71l3.6-11.414a7.674,7.674,0,0,0-6.061-9.878l-24.66-4.1a2.949,2.949,0,0,1,.385-5.857L48.2,40.2A11.4,11.4,0,0,1,59.72,54.029l-1.753,8.025A7.917,7.917,0,0,0,65.7,71.66h6.36A77.025,77.025,0,0,1,60.115,93.608c-.544.7-1.069,1.413-1.585,2.132H53.974A17.533,17.533,0,0,1,39.7,88.5Zm23.08,154.5a5.8,5.8,0,0,1-6.037,5.507,6.251,6.251,0,0,1-4.356-1.707,6.956,6.956,0,0,0-9.649,0,6.249,6.249,0,0,1-4.356,1.708,5.53,5.53,0,1,1,.011-11.013H38.4a5.473,5.473,0,0,0,3.893-1.6,5.371,5.371,0,0,0,1.587-3.827V215.444a19.387,19.387,0,0,0,7.355,0V232.07a5.37,5.37,0,0,0,1.587,3.827,5.479,5.479,0,0,0,3.9,1.6h.012A5.8,5.8,0,0,1,62.777,243.007Zm160.9,0a5.8,5.8,0,0,1-6.037,5.507,6.251,6.251,0,0,1-4.356-1.707,6.956,6.956,0,0,0-9.649,0,6.249,6.249,0,0,1-4.356,1.708,5.53,5.53,0,1,1,.01-11.013h.012a5.473,5.473,0,0,0,3.893-1.6,5.371,5.371,0,0,0,1.587-3.827V215.448a19.5,19.5,0,0,0,7.355,0V232.07a5.37,5.37,0,0,0,1.587,3.827,5.479,5.479,0,0,0,3.9,1.6h.012A5.8,5.8,0,0,1,223.674,243.007Zm-13.355-95.885a71.118,71.118,0,0,0,.193-17.318,29.121,29.121,0,0,1,26.842,27.271,28.719,28.719,0,0,1-10.58,23.99,16.982,16.982,0,0,0-6.156,13.228v1.842a12.163,12.163,0,1,1-24.325,0v-1.872a17.1,17.1,0,0,0-2.67-9.145A75.1,75.1,0,0,0,210.319,147.122Zm35.73-99.8-24.66,4.1a7.674,7.674,0,0,0-6.061,9.878l3.6,11.414a17.7,17.7,0,0,1-16.884,23.028h-4.556c-.516-.719-1.041-1.431-1.585-2.131a77.009,77.009,0,0,1-11.947-21.949h6.359a7.917,7.917,0,0,0,7.734-9.606l-1.753-8.025A11.4,11.4,0,0,1,207.816,40.2l37.847,1.266a2.95,2.95,0,0,1,.385,5.858Z",
  transform: "translate(0 -11.058)",
  fill: "rgba(147,147,147,0.69)"
});

function SvgChicken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chicken",
    xmlns: "http://www.w3.org/2000/svg",
    width: 256.015,
    height: 244.956,
    viewBox: "0 0 256.015 244.956",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChicken);
export default __webpack_public_path__ + "static/media/chicken.6d5e8051.svg";
export { ForwardRef as ReactComponent };